import { Button, Carousel, Flex, Typography } from 'antd';
import { GameCards } from 'components/GameCards';
import { ImagePlayer } from 'components/ImagePlayer';
import React, { CSSProperties } from 'react';
import { imagePlayerDataArray } from 'db/data';
import { relative } from 'path';
import { OverlayComp } from 'components/OverlayComp';
import { Parallax } from 'react-parallax';
import { useNavigate } from 'react-router-dom';



export const HomePage: React.FC = () => {
	const navigateTo = useNavigate();
	return (
	<Flex vertical align="center" gap={150} style={{ marginTop: 300 }}>
		<img src={require('images/bg.jpg')} style={fullScreenBgStyle} />
		<Typography.Title style={{ textAlign: 'center' }}>
			Coding Aural & Visual Odysseys
			<Typography.Paragraph>we make games.</Typography.Paragraph>
		</Typography.Title>

		<ImagePlayer data={imagePlayerDataArray} width="960px" height="540px" />

		<Flex vertical>
			<Parallax bgImage={require('images/banner7.jpg')} strength={0}>
				<Flex vertical justify="center" style={{ textAlign: 'center', margin: 'auto', height: 540, width: '100vw', boxSizing: 'border-box' }}>
					<Typography.Title style={{ color: 'black' }}>
						We Are Growing
						<Typography.Paragraph style={{ color: 'black' }}>
							Founded on the idea of independent teams freely decide what project to take on.
						</Typography.Paragraph>
						<Button type="primary" onClick={() => navigateTo("about")}>
							Join a team
						</Button>
					</Typography.Title>
				</Flex>
			</Parallax>
			{/* <Parallax bgImage={require('images/banner2.jpg')} strength={0}>
				<Flex vertical justify="center" style={{ textAlign: 'center', margin: 'auto', height: 540, width: '100vw', boxSizing: 'border-box' }}>
					<Typography.Title style={{ color: 'white' }}>
						We are Teams
						<Typography.Paragraph style={{ color: 'white' }}>
							Founded on the idea of independent teams freely decide what project to take on.
						</Typography.Paragraph>
						<Button type="primary">Join a team</Button>
					</Typography.Title>
				</Flex>
			</Parallax>
			<Parallax bgImage={require('images/banner3.png')} strength={0}>
				<Flex vertical justify="center" style={{ textAlign: 'center', margin: 'auto', height: 540, width: '100vw', boxSizing: 'border-box' }}>
					<Typography.Title style={{ color: 'white' }}>
						Random ideas to reality
						<Typography.Paragraph style={{ color: 'white' }}>
							Everything starts with an idea sparks. To make a few games, we killed dozens.
						</Typography.Paragraph>
						<Button type="primary">See our games</Button>
					</Typography.Title>
				</Flex>
			</Parallax>
			<Parallax bgImage={require('images/banner5.png')} strength={0}>
				<Flex vertical justify="center" style={{ textAlign: 'center', margin: 'auto', height: 540, width: '100vw', boxSizing: 'border-box' }}>
					<Typography.Title style={{ color: 'white' }}>
						We are growing
						<Typography.Paragraph style={{ color: 'white' }}>Find a group you love to work with! Join a team and grow with us.</Typography.Paragraph>
						<Flex justify='center' gap={10} wrap='wrap'>
							<Button type="primary">Join us</Button>
							<Button >See more</Button>
						</Flex>
					</Typography.Title>
				</Flex>
			</Parallax> */}
		</Flex>

		<GameCards />
	</Flex>
)};

const fullScreenBgStyle:CSSProperties = {
	position: "absolute", zIndex: -100,maxWidth: "100%", height: "100%", width: "auto", objectFit: "cover"	
}

